import React from "react";
import { useCompanyTimezone, useDisplayTimezone } from "hooks/useTimezone";
import { fmtDatetime } from "utils/time-utils";
import { Instant } from "@js-joda/core";
import { LoadingTimeDisplayProps } from "./LoadingTimeDisplayTypes";

export default function LoadingTimeDisplay(props: LoadingTimeDisplayProps) {
  const displayTz = useDisplayTimezone();
  const companyTz = useCompanyTimezone();

  const now = Instant.now();

  return (
    <div className="flex flex-column align-items-center" style={{ fontSize: 16 }}>
      <span>
        Time at display timezone ({displayTz.id()}):{" "}
        <i className="font-bold">{fmtDatetime(now, displayTz)}</i>
      </span>
      <span>
        Time at company timezone ({companyTz.id()}):{" "}
        <i className="font-bold">{fmtDatetime(now, companyTz)}</i>
      </span>
      <span>
        Time difference:{" "}
        <i className="font-bold">
          {(displayTz.rules().offset(now).totalSeconds() - companyTz.rules().offset(now).totalSeconds()) /
            3600}{" "}
          hours
        </i>
      </span>

      <span className="pt-2">
        Reference time old: {props.referenceTime}, new: {props.instantReferenceTime?.toString()}
      </span>
      <span>
        From old: {props.from}, new: {props.instantFrom?.toString()}
      </span>
      <span>
        To old: {props.to}, new: {props.instantTo?.toString()}
      </span>
    </div>
  );
}
